import { render, staticRenderFns } from "./MiniSensor.vue?vue&type=template&id=2db87457&scoped=true&lang=pug&"
import script from "./MiniSensor.vue?vue&type=script&lang=ts&"
export * from "./MiniSensor.vue?vue&type=script&lang=ts&"
import style0 from "./MiniSensor.vue?vue&type=style&index=0&id=2db87457&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db87457",
  null
  
)

export default component.exports